import { create } from 'zustand';

export type FloorTransitionMode = 'swap' | 'enter';

interface FloorTransitionState {
  active: boolean;
  floor: number | null;
  mode: FloorTransitionMode;
  swap: (() => void) | null;
  start: (floor: number, mode: FloorTransitionMode, swap?: () => void) => void;
  end: () => void;
}

export const useFloorTransitionStore = create<FloorTransitionState>((set) => ({
  active: false,
  floor: null,
  mode: 'enter',
  swap: null,
  start: (floor, mode, swap) =>
    set({ active: true, floor, mode, swap: swap ?? null }),
  end: () => set({ active: false, floor: null, swap: null }),
}));
